<script>
export default {
  components: {},
  props: {
    isMenuOpened: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    }
  },
  mounted() {
    this.selectMenu();
  },
  data: function() {
    return {
      selected: 0,
      activeClass: "",
      empty: ""
    };
  },
  methods: {
    selectMenu() {
      this.selectMenu = 0;
      switch (this.$router.currentRoute.name) {
        case "calendario":
          this.selected = 1;
          break;
        case "atendimentos":
          this.selected = 2;
          break;
        case "tarefas":
          this.selected = 3;
          break;
        case "cadastros":
          this.selected = 4;
          break;
        case "chamado":
          this.selected = 5;
          break;
      }
    },
    permiteAcesso(permission) {
      return this.user.Permissions.includes(permission);
    }
  }
};
</script>

<template>
  <b-collapse id="navigation" v-model="isMenuOpened">
    <!-- Navigation Menu-->
    <ul class="navigation-menu mt-1">
      <li v-bind:class="[!(selected === 1) ? activeClass : 'active', empty]">
        <a href="/Calendario">
          <i class="remixicon-calendar-event-fill"></i>Calendário
        </a>
      </li>
      <li v-bind:class="[!(selected === 2) ? activeClass : 'active', empty]">
        <a href="/Atendimentos">
          <i class="remixicon-calendar-todo-fill"></i>Atendimentos
        </a>
      </li>
      <li
        v-if="permiteAcesso('VisualizaTarefa')"
        v-bind:class="[!(selected === 3) ? activeClass : 'active', empty]"
      >
        <a href="/Tarefas"> <i class="remixicon-todo-line"></i>Tarefas </a>
      </li>
      <li
        v-if="user.perfil === 'Administrador'"
        v-bind:class="[!(selected === 4) ? activeClass : 'active', empty]"
      >
        <a href="/Cadastros">
          <i class="remixicon-file-copy-2-line"></i>Cadastros
        </a>
      </li>
      <li
        v-bind:class="[!(selected === 5) ? activeClass : 'active', empty]"
        v-if="permiteAcesso('AcessoChamado')"
      >
        <a href="/Chamado">
          <i class="remixicon-price-tag-3-line"></i>Chamados
        </a>
      </li>
    </ul>
    <!-- End navigation menu -->

    <div class="clearfix"></div>
  </b-collapse>
  <!-- end navbar-custom -->
</template>

<style lang="scss"></style>
